import humps from 'humps'

export function parseResponseObject (response) {
  response.data = humps.camelizeKeys(response.data)
  return response
}



// WEBPACK FOOTER //
// ./src/api/utils.js